import { IDUtils } from '@core/lib/utils/model-utils';

export interface ContactTypeInterface {
  id: number;
  name: string;
}

export class ContactType implements ContactTypeInterface {
  constructor(
    public id = IDUtils.id(),
    public name = '',
  ) {}

  static adapt(item: any): ContactType {
    return new ContactType(item.id ? item.id : IDUtils.id(), item.name);
  }
}
